import { render } from "./ReportDownload.vue?vue&type=template&id=d06816a6"
import script from "./ReportDownload.vue?vue&type=script&lang=js"
export * from "./ReportDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__